import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconBluetoothOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconBluetoothOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-bluetooth-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M8.86546 9.57262L2.14645 2.85361C1.95118 2.65835 1.95118 2.34177 2.14645 2.14651C2.34171 1.95125 2.65829 1.95125 2.85355 2.14651L17.8536 17.1465C18.0488 17.3418 18.0488 17.6584 17.8536 17.8536C17.6583 18.0489 17.3417 18.0489 17.1464 17.8536L13.3541 14.0613L10.5821 17.473C10.5581 17.5025 10.5324 17.5297 10.5051 17.5546L10.3671 17.7239C10.1667 17.9698 9.83319 18.063 9.5343 17.9566C9.23541 17.8502 9.03579 17.5673 9.03579 17.25V14.0001H9.04005V11.3612L7.22192 12.833C6.89998 13.0936 6.42771 13.0439 6.16709 12.722C5.90647 12.4 5.95618 11.9277 6.27813 11.6671L8.86546 9.57262ZM12.2878 12.995L10.54 11.2472V11.7752L10.5358 11.7718V15.1429L11.4673 14.0001H11.4712L12.2878 12.995ZM13.7213 7.5835L11.4994 9.37813L9.04005 6.91877V4.00006H9.03579V2.75004C9.03579 2.43278 9.23541 2.14985 9.5343 2.04346C9.83319 1.93708 10.1667 2.03027 10.3671 2.27618L13.8314 6.52618C13.9575 6.68081 14.0167 6.87929 13.996 7.07771C13.9754 7.27613 13.8765 7.45815 13.7213 7.5835ZM11.5281 7.41713L11.5328 7.42295L12.1927 6.88995L10.5358 4.85719V8.22045L11.5281 7.41713Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-bluetooth-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-bluetooth-off", "wpp-icon-bluetooth-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-bluetooth-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-bluetooth-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconBluetoothOff$1);
      }
      break;
  } });
}

const WppIconBluetoothOff = WppIconBluetoothOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconBluetoothOff, defineCustomElement };
